import { render } from "./DeployVnfAppliance.vue?vue&type=template&id=635384c3&scoped=true"
import script from "./DeployVnfAppliance.vue?vue&type=script&lang=js"
export * from "./DeployVnfAppliance.vue?vue&type=script&lang=js"

import "./DeployVnfAppliance.vue?vue&type=style&index=0&id=635384c3&lang=less&scoped=true"
import "./DeployVnfAppliance.vue?vue&type=style&index=1&id=635384c3&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635384c3"]])

export default __exports__